/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../api/types.generated";
export type SetEventAttendeeHasIdMutationVariables = Types.Exact<{
  event_attendee_id: Types.Scalars["Float"];
  has_id: Types.Scalars["Boolean"];
}>;

export type SetEventAttendeeHasIdMutation = {
  setEventAttendeeHasId: Pick<Types.EventAttendee, "id" | "has_id">;
};

export const SetEventAttendeeHasIdDocument = gql`
  mutation SetEventAttendeeHasId(
    $event_attendee_id: Float!
    $has_id: Boolean!
  ) {
    setEventAttendeeHasId(
      event_attendee_id: $event_attendee_id
      has_id: $has_id
    ) {
      id
      has_id
    }
  }
`;

/**
 * __useSetEventAttendeeHasIdMutation__
 *
 * To run a mutation, you first call `useSetEventAttendeeHasIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetEventAttendeeHasIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setEventAttendeeHasIdMutation, { data, loading, error }] = useSetEventAttendeeHasIdMutation({
 *   variables: {
 *      event_attendee_id: // value for 'event_attendee_id'
 *      has_id: // value for 'has_id'
 *   },
 * });
 */
export function useSetEventAttendeeHasIdMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SetEventAttendeeHasIdMutation,
    SetEventAttendeeHasIdMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    SetEventAttendeeHasIdMutation,
    SetEventAttendeeHasIdMutationVariables
  >(SetEventAttendeeHasIdDocument, baseOptions);
}
export type SetEventAttendeeHasIdMutationHookResult = ReturnType<
  typeof useSetEventAttendeeHasIdMutation
>;
export type SetEventAttendeeHasIdMutationResult =
  ApolloReactCommon.MutationResult<SetEventAttendeeHasIdMutation>;
export type SetEventAttendeeHasIdMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    SetEventAttendeeHasIdMutation,
    SetEventAttendeeHasIdMutationVariables
  >;
